import React, { memo } from "react";

const Category = ({ item, updateCurrentFilter, checked }) => {
    return (
        <li key={item.id} className="otc-filters-category" >
            <div className="checkbox-container">
                <input id={item.id} type="checkbox" onChange={updateCurrentFilter} checked={checked} name="" value={item.id}></input>
                <label htmlFor={item.id}>{item.description}</label>
            </div>
        </li>
    );
}

export default memo(Category);